import Instance from "./Instance";

// Order endpoints (OrderProduct.md §6).
// All require a signed-in staff JWT — the shared Instance already attaches
// Authorization: Bearer <token>. Reads (list / count / by id) are open to every
// role; updateOrderStatus stays admin / ipadadmin only.

// List orders. params: { status?, page?, limit? }
export const getOrders = async (params = {}) => {
    try {
        const response = await Instance.get("/api/v1/orders", { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching orders:", error);
        throw error;
    }
};

// Get a single order by id (handledBy populated).
export const getOrderById = async (id) => {
    try {
        const response = await Instance.get(`/api/v1/orders/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching order:", error);
        throw error;
    }
};

// Update an order's status. body: { status, staffNote? }
// status ∈ pending | confirmed | rejected | cancelled | fulfilled
export const updateOrderStatus = async (id, body) => {
    try {
        const response = await Instance.patch(`/api/v1/orders/${id}/status`, body);
        return response.data;
    } catch (error) {
        console.error("Error updating order status:", error);
        throw error;
    }
};
